export function transitionTools(item: PlaybookItem): PlaybookTool[] {
  return (item.transitions || []).map((transition, i) => ({ name: `transition_${i + 1}`, description: transition.description, transition: true }))
}

export function transitionByName(item: PlaybookItem, name: string): PlaybookTransition | undefined {
  return name.startsWith("transition_") ? item.transitions?.[Number(name.slice("transition_".length)) - 1] : undefined
}
